import cn from 'classnames'

import { Guidance } from './Guidance'
import { DoubleChat } from './DoubleChat'

const icons = {
  chat: DoubleChat,
  guidance: Guidance,
}

export type IconKind = keyof typeof icons

export const Icon = ({
  kind,
  className,
  ...props
}: {
  kind: IconKind
  className?: string
}) => {
  const Comp = icons[kind]

  if (!Comp) return null

  return (
    <Comp
      {...props}
      aria-hidden={true}
      className={cn({
        'mc-icon': true,
        [className ?? '']: !!className,
        'mc-icon--placeholder': !Comp,
      })}
      role='img'
    />
  )
}
